import { Injectable } from '@angular/core';
import { Logging } from '@web/logging';

@Injectable({ providedIn: 'root' })
export class LoggingService extends Logging {}
